import { useLayoutEffect } from "react";
import { Link } from "react-router-dom";

import { clearSessionToken, getRefreshCredential, getSessionToken } from "../utils/session";
import { clearLocalDrafts } from "../services/drafts";
import { endSignedOutDevice } from "../services/deviceSessions";


export default function Logout() {

	// In a layout effect, not during render: clearing the token announces the
	// change (utils/session.js), and every per-user cache in the shell resets
	// on it — state updates that React refuses to take while another
	// component is rendering.
	useLayoutEffect( () => {
		// The phone app's device session (KPR-1674) ends on the server too, so
		// Account > Devices stops listing it. The pair is taken before it is
		// forgotten, and the call goes after: nothing waits on it.
		const held = { token: getSessionToken(), refreshToken: getRefreshCredential() };
		clearSessionToken();
		if ( held.refreshToken ) endSignedOutDevice( held );
		// Drafts left in this browser from before they moved to the server go
		// with the session: the next person to sign in here must not find them.
		clearLocalDrafts();
	}, [] );

	return <>
		<h1>You have been logged out</h1>
		<Link to='/login'>
			Log in
		</Link>
	</>;

}
